import script from "./UserProfileSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileSidebar.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileSidebar.vue?vue&type=style&index=0&id=bab200d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bab200d2"]])

export default __exports__